module.exports = __webpack_public_path__ + "img/chalk_10.c524859c.png";